<div class="tcm-message-modal-header" *ngIf="title">
    <div class="tcm-message-modal-title">{{title}}</div>
</div>
<div class="tcm-message-modal-body">
    <div class="tcm-message-modal-content">
        <ng-template ngIf="!template">
            {{content}}
        </ng-template>
        <form #frm="ngForm" *ngIf="template">
            <ng-template [ngTemplateOutlet]="template"
                         [ngTemplateOutletContext]="{ data: templateData, modal: {close: closeExternal}, form: frm}">
            </ng-template>
        </form>
    </div>
</div>
<div class="tcm-message-modal-footer">
    <div class="command-panel">
        <button type="button" *ngFor="let item of buttons" class="btn" [ngClass]="'btn-' + item.cssClass"
                (click)="executeAction($event, item)">{{item.title}}</button>
    </div>
</div>
